import { BaseService } from '../../infra/base.service'
import type { BalanceAllEntity, BalanceEntity } from './balance.entity'
import type { BrokerBalancesRepository } from './balances.repository'

export class BrokerBalancesService extends BaseService<BalanceEntity> {
    constructor(private rep: BrokerBalancesRepository) {
        super(rep)
    }

    async getAllBalance(): Promise<BalanceAllEntity> {
        return await this.rep.getAllBalance()
    }
}
